/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* jshint nomen:false */
// eslint-disable-next-line no-unused-vars
define(['leaflet', 't', './incidentMarker'], function(L, T, incidentMarker) {
    'use strict';

    var clusterPopupTemplate = new T(
        '    <div>' +
            '    <div><b>Incidents in this area: {{=incidentsNo}}</b></div>' +
            '    <hr/>' +
            '    <div><b>{{=features.length}} most severe incidents</b>' +
            '        <span style="color: lightgray">(Ordered by severity and delay)</span>' +
            '    </div>' +
            '    <hr/>' +
            '    <div style="font-weight: bold">' +
            '        <div class="cluster-popup-category-column">Category</div>' +
            '        <div class="cluster-popup-length-column">Length</div>' +
            '        <div class="cluster-popup-streets-column">Streets</div>' +
            '        <div style="clear: both"></div>' +
            '        <hr/>' +
            '    </div>' +
            '    {{@features}}' +
            '        <div>' +
            '            <div class="cluster-popup-category-column">' +
            '                <div class="traffic-icon">' +
            '                    <div class="icon-circle-{{=_val.properties.incidentSeverity}}">' +
            '                        <div class="icon-{{=_val.properties.icon}}-white"></div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="cluster-popup-length-column">' +
            '                {{=_val.properties.formattedLength}}' +
            '            </div>' +
            '            <div class="cluster-popup-streets-column">' +
            '                <div><span>From:</span>{{=_val.properties.from}}</div>' +
            '                <div><span>To:</span>{{=_val.properties.to}}</div>' +
            '            </div>' +
            '            <div style="clear: both"></div>' +
            '            <hr/>' +
            '        </div>' +
            '    {{/@features}}' +
            '</div>'
    );

    function compareDelays(p1, p2) {
        var d1 = p1.delaySeconds || 0;
        var d2 = p2.delaySeconds || 0;
        return d2 - d1;
    }

    function compareSeverity(p1, p2, severity) {
        var is1 = p1.incidentSeverity;
        var is2 = p2.incidentSeverity;
        if (is1 === severity) {
            return -1;
        } else if (is2 === severity) {
            return 1;
        }
        return 0;
    }

    function featuresComparator(f1, f2) {
        var severities = ['major', 'moderate', 'minor', 'unknown', 'undefined'];
        var severityComparisonResult = 0;
        var i;

        var p1 = f1.properties;
        var p2 = f2.properties;

        if (p1.incidentSeverity === p2.incidentSeverity) {
            return compareDelays(p1, p2);
        }

        for (i = 0; i < severities.length; ++i) {
            severityComparisonResult = compareSeverity(p1, p2, severities[i]);
            if (severityComparisonResult !== 0) {
                return severityComparisonResult;
            }
        }

        return severityComparisonResult;
    }

    function formatLength(lengthInMeters) {
        if (!lengthInMeters) {
            return '---';
        }

        if (lengthInMeters > 1000) {
            return (lengthInMeters / 1000).toPrecision(3) + ' km';
        }
        return lengthInMeters + ' m';
    }

    function getIconOptions(feature) {
        var severity = feature.properties.incidentSeverity || 'unknown';
        var clusterSize = feature.properties.clusterSize;

        return {
            icon: null,
            popupAnchor: [0, -5],
            background: { iconSize: [20, 20], iconAnchor: [10, 10], icon: 'icon-circle-' + severity },
            content: {
                content: clusterSize < 100 ? clusterSize : '99+',
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                style: { 'color': '#fff', 'font-weight': 'bold', 'font-size': '11px' }
            }
        };
    }

    L.Marker.ClusterIncidentMarker = L.Marker.IncidentMarker.extend({
        options: {
            createPopup: true
        },
        onAdd: function(map) {
            this._map = map;
            if (!this.options.createPopup) {
                map.on('click', this._onClick, this);
            }
            L.Marker.prototype.onAdd.call(this, map);
        },
        onRemove: function(map) {
            if (!this.options.createPopup) {
                map.off('click', this._onClick, this);
            }
            L.Marker.prototype.onRemove.call(this, map);
        },
        _onClick: function() {
            if (this.feature.propterites.clusterBounds) {
                this._map.fitBounds(this.feature.propterites.clusterBounds);
            } else {
                this._map.setZoomAround(this.getLatLng(), this._map.getZoom() + 2);
            }
        },
        _updateIcon: function() {
            this.setIcon(L.svgIcon(getIconOptions(this.feature)));
        },
        _updatePopup: function() {
            var popupContent;
            var featuresToShow;
            if (!this.options.createPopup) {
                return;
            }

            featuresToShow = this.feature.properties.features
                .slice(0)
                .sort(featuresComparator)
                .slice(0, 4)
                .map(function(feature) {
                    var properties = Object.assign({}, feature.properties, {
                        icon: this.iconsMapping[feature.properties.incidentCategory],
                        formattedLength: formatLength(feature.properties.lengthMeters)
                    });
                    return Object.assign({}, feature, {
                        properties: properties
                    });
                }, this);

            popupContent = clusterPopupTemplate.render({
                features: featuresToShow,
                incidentsNo: this.feature.properties.features.length
            });

            if (this.getPopup()) {
                this.setPopupContent(popupContent);
            } else {
                this.bindPopup(popupContent, { autoPan: false });
            }
        }
    });

    return function(feature, latlng, options) {
        if (!feature || !feature.properties) {
            return null;
        }

        return new L.Marker.ClusterIncidentMarker(feature, latlng, {
            createPopup: options.createPopupForCluster
        });
    };
});



// WEBPACK FOOTER //
// ./display/layers/markers/clusterIncidentMarker.js